<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "AuthorAvatar",
  extends: BaseImageElement,
  elementPanelSettings: {
    displayName: "Author Avatar",
    displayIcon: "image",
    elementGroup: "storyElements",
    elementType: "element",
  },
  mixins: [StoryPageElementMixin, FallbackImageElementMixin],
  computed: {
    imageSrc() {
      return this.entity.authoringAvatarUrl;
    },
    fallbackImageSrc() {
      let imageUrl = this.getOptionValue(this.FallbackImage);
      if (imageUrl === "") {
        imageUrl = "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/avatar-default.png";
      }
      return imageUrl;
    },
  },
};
</script>
